import { Modal } from 'antd';

class ModalService {
  constructor() {
    this.modal = null;
  }

  setModal(modal) {
    this.modal = modal;
  }

  confirm(config) {
    if (this.modal) {
      return this.modal.confirm(config);
    } else {
      return Modal.confirm(config);
    }
  }

  warning(config) {
    if (this.modal) {
      return this.modal.warning(config);
    } else {
      return Modal.warning(config);
    }
  }

  error(config) {
    if (this.modal) {
      return this.modal.error(config);
    } else {
      return Modal.error(config);
    }
  }

  info(config) {
    if (this.modal) {
      return this.modal.info(config);
    } else {
      return Modal.info(config);
    }
  }

  success(config) {
    if (this.modal) {
      return this.modal.success(config);
    } else {
      return Modal.success(config);
    }
  }

  destroyAll() {
    if (this.modal) {
      this.modal.destroyAll();
    } else {
      Modal.destroyAll();
    }
  }
}

export default new ModalService();
